export const CURRENT_HOST = 'soutuya.com';

const pathList = CURRENT_HOST.split('.');
let main = '';
if (pathList.length === 3) {
  main = pathList.slice(1).join('.');
} else {
  main = CURRENT_HOST;
}

export const CURRENT_MAIN_HOST = main;
